import React from 'react';

import "./ContactButton.scss";
import { Button } from '@randajan/jet-react/dom/form';
import { usePagePop } from '../../../hooks/usePagePop';
import { ContactScreen } from '../ContactScreen/ContactScreen';
import { usePopDocs } from '../../Docs/useDocs';


export const ContactButton = (props)=>{
    const {} = props;

    const popDocs = usePopDocs();

    const popContact = usePagePop(<ContactScreen/>, "hash.contact", "up");
    
    return (
        <Button className="ContactButton" onSubmit={_=>popContact.up()}>
            i
        </Button>
    )
}

